import ReactGA from "react-ga4";

export const initGA4 = () => {
  ReactGA.initialize("G-DFWLHBHG91");
};

export const sendPageViewToGA = (page: string) => {
  ReactGA.send({ hitType: "pageview", page });
};

export const sendEventToGa = (action: string, category?: string) => {
  const page = window.location.pathname.replaceAll("/", "").toLowerCase();
  ReactGA.event({
    category: category || page,
    action: `${action}__page=${page}`,
  });
};

export const trackQuizStart = () => {
  sendEventToGa("quiz_view");
};
